import React, { Fragment } from 'react';
import { Divider, Grid, List } from '@mui/material';
import CylinderRow from '../CylinderRow';
import './index.css';
import { isMobile } from '../../../utils'

const CylinderSelect = ({
    locationId,
    setChecked,
    setCylinderDetails,
    cylinders,
    cylinderIdsToMove,
    selectedCylinderId,
    closeCylinderDetails,
}) => {
    const half_way = Math.floor(cylinders.length / 2);
    const list_1 = cylinders.slice(0, half_way);
    const list_2 = cylinders.slice(half_way);
    const containerProps = {
        container: true,
        direction: 'row',
        alignItems: 'center',
        overflow: 'auto',
        className: 'cylinderList'
    };
    
    if (isMobile) {
        return (
            <Grid {...containerProps}>
                <Grid item xs={12}>
                    <List>
                        {cylinders.map((cylinder, index) => (
                            <Fragment key={index}>
                                <CylinderRow
                                    locationId={locationId}
                                    name={cylinder.name}
                                    setChecked={setChecked}
                                    setCylinderDetails={setCylinderDetails}
                                    cylinderId={cylinder.id}
                                    cylinderIdsToMove={cylinderIdsToMove}
                                    cylinder={cylinder}
                                    selectedCylinderId={selectedCylinderId}
                                    closeCylinderDetails={closeCylinderDetails}
                                />
                                <Divider variant="middle" />
                            </Fragment>
                        ))}
                    </List>
                </Grid>
            </Grid>
        );
    }
    
    return (
        <Grid {...containerProps}>
            <Grid item xs={12} md={6}>
                <List>
                    {list_1.map((cylinder, index) => (
                        <Fragment key={index}>
                            <CylinderRow
                                locationId={locationId}
                                name={cylinder.name}
                                setChecked={setChecked}
                                setCylinderDetails={setCylinderDetails}
                                cylinderId={cylinder.id}
                                cylinderIdsToMove={cylinderIdsToMove}
                                cylinder={cylinder}
                                selectedCylinderId={selectedCylinderId}
                                closeCylinderDetails={closeCylinderDetails}
                            />
                            <Divider variant="middle" />
                        </Fragment>
                    ))}
                </List>
            </Grid>

            <Grid item xs={12} md={6}>
                <List>
                    {list_2.map((cylinder, index) => (
                        <Fragment key={index}>
                            <CylinderRow
                                locationId={locationId}
                                name={cylinder.name}
                                setChecked={setChecked}
                                setCylinderDetails={setCylinderDetails}
                                cylinderId={cylinder.id}
                                cylinderIdsToMove={cylinderIdsToMove}
                                cylinder={cylinder}
                                selectedCylinderId={selectedCylinderId}
                                closeCylinderDetails={closeCylinderDetails}
                            />
                            <Divider variant="middle" />
                        </Fragment>
                    ))}
                </List>
            </Grid>
        </Grid>
    );
}; 

export default CylinderSelect;
